import { Dayjs } from "dayjs";
import { Seller } from "./Seller";

export interface TelemetryPreference {
    enabled: boolean;
    modules: TelemetryModuleConfiguration[];
}

export interface TelemetryModuleConfiguration {
    id?: ID;
    enabled: boolean;
    module: {
        id: ID;
    };
    parameters: TelemetryModuleParameterValue[];
}

export interface TelemetryModuleParameterValue {
    key: string;
    value?: string;
}

export interface Telemetry {
    data: TelemetryData[];
}

export interface TelemetryData {
    id: ID;
    module: {
        id: ID;
    };
    values: TelemetryModuleValue[];
}

export interface TelemetryModuleValue {
    key: string;
    value: string;
}

export interface TelemetryModule {
    id?: ID;
    name: string;
    description: string;
    seller?: Seller;
    parameters: TelemetryModuleParameter[];
    updatedAt?: Dayjs;
    picture?: { id: string; src: string };
}

export interface TelemetryModuleParameter {
    id?: ID;
    type: string;
    key: string;
    value?: string;
    pattern?: string;
    label: string;
    caption: string;
    retry?: number;
}

export enum TelemetryParameterType {
    STRING = "string",
    COOKIE = "cookie",
    BOOLEAN = "boolean",
    FUNCTION = "function",
    SECRET = "secret",
    QUERYSTRING = "query_string",
    PROPERTY = "property",
}
